var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsletterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.427 4.948C48.51 24.75 26.125 47.134 6.323 32.052-8.759 12.25 13.625-10.134 33.427 4.948",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 11.947H28a3 3 0 00-3 3v20a3 3 0 003 3h32a3 3 0 003-3v-20a3 3 0 00-3-3",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 22.947v-8a3 3 0 013-3h32a3 3 0 013 3v20a3 3 0 01-3 3H28a3 3 0 01-3-3v-9",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 14.947L47.518 25.645a5.403 5.403 0 01-7.037 0L28 14.947M49 23.947l11 11M39 23.947l-5 5",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 31.947H4a3 3 0 00-3 3v20a3 3 0 003 3h32a3 3 0 003-3v-20a3 3 0 00-3-3",
    fill: "#E74A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 44.947v-10a3 3 0 00-3-3H4a3 3 0 00-3 3v20a3 3 0 003 3h32a3 3 0 003-3v-6",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 34.947L23.518 45.645a5.403 5.403 0 01-7.037 0L4 34.947M25 43.947l11 11M14.5 44.447L4 54.947M29 22.947H17M21 11.947H10M35 45.947h12M43 57.947h11",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E8E9EA",
    strokeWidth: 2,
    d: "M20 64.947h28M47 4.947H19"
  }))));
}
export default SvgNewsletterIcon;